import { API_BASE_URL } from './config';

// Get token from localStorage
const getToken = () => {
  return localStorage.getItem('authToken');
};

// Set token in localStorage
const setToken = (token) => {
  if (token) {
    localStorage.setItem('authToken', token);
  } else {
    localStorage.removeItem('authToken');
  }
};

// API call function with token
const apiCall = async (endpoint, method = 'GET', data = null) => {
  const headers = {
    'Content-Type': 'application/json'
  };

  const token = getToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const config = {
    method,
    headers
  };

  if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
    config.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'API request failed');
    }

    return result;
  } catch (error) {
    throw error;
  }
};

// Auth API calls
export const authAPI = {
  signup: (data) => apiCall('/auth/signup', 'POST', data),
  login: (data) => apiCall('/auth/login', 'POST', data),
  forgotPassword: (data) => apiCall('/auth/forgot-password', 'POST', data),
  resetPassword: (token, data) => apiCall(`/auth/reset-password/${token}`, 'POST', data),
  changePassword: (data) => apiCall('/auth/change-password', 'POST', data),
  getCurrentUser: () => apiCall('/auth/me', 'GET'),
  logout: () => {
    setToken(null);
    return { success: true };
  }
};

// Export utilities
export { getToken, setToken, apiCall };
